import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { CHART_PROPS_VDP } from 'site-modules/shared/constants/price-checker';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { getTmvChartData } from 'site-modules/shared/utils/price-checker';
import { PricingChart } from 'site-modules/shared/components/pricing-chart/pricing-chart';

import './price-checker-chart-vdp.scss';

export function PriceCheckerChartVdp({
  tmvData = null,
  userMsrp = null,
  userDealerPrice = null,
  bestDealPrice = null,
  isMobile = false,
  isPartnerListing = false,
}) {
  useEffect(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_SHOW_CONTENT,
        subaction_name: TrackingConstant.PRICE_COMPARISON,
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
        creative_id: 'edm-entry-negotiation',
      },
    });
  }, []);

  const tmvChartData =
    tmvData && userDealerPrice
      ? getTmvChartData({ tmvData, userMsrp, userDealerPrice, bestDealPrice, isVDP: true })
      : null;

  let customPriceLabels = [
    { index: CHART_PROPS_VDP.COMMON.keyPointsIndex.lowEnd },
    { index: CHART_PROPS_VDP.COMMON.keyPointsIndex.highEnd, end: true },
  ];
  if (tmvChartData) {
    customPriceLabels = [
      {
        label: getPriceString(tmvChartData.maxGreatPrice),
        index: CHART_PROPS_VDP.COMMON.keyPointsIndex.lowEnd,
      },
      {
        label: getPriceString(tmvChartData.maxFairPrice),
        index: CHART_PROPS_VDP.COMMON.keyPointsIndex.highEnd,
        end: true,
      },
      {
        label: getPriceString(tmvChartData.maxGoodPrice),
        index: CHART_PROPS_VDP.COMMON.keyPointsIndex.middleEnd,
      },
    ];
  }

  const isPriceCopyDisabled = !isPartnerListing;

  return (
    <div className="price-checker-chart-vdp text-center">
      <div className="d-flex flex-column justify-content-end">
        {!isPriceCopyDisabled && (
          <Fragment>
            {tmvChartData ? (
              <div className="heading-6 d-inline-block mb-0_25">{tmvChartData.dealerPrice.cta}</div>
            ) : (
              <div className="heading-4">Check your price quote</div>
            )}
          </Fragment>
        )}
        {/* 'd-none' to have animation on first input */}
        <div
          className={classnames('user-price text-primary-darker fw-bold', {
            'd-none': !tmvChartData,
            'd-flex align-items-center justify-content-center': tmvChartData,
          })}
        >
          {get(tmvChartData, 'dealerPrice.label')} Price: {getPriceString(userDealerPrice)}
        </div>
      </div>
      <PricingChart
        {...CHART_PROPS_VDP.COMMON}
        dataPoints={tmvChartData ? CHART_PROPS_VDP.DATA_POINTS.WITH_DATA : CHART_PROPS_VDP.DATA_POINTS.WITHOUT_DATA}
        customPriceLabels={customPriceLabels}
        selectedPriceIndex={get(tmvChartData, 'dealerPrice.index')}
        isMobile={isMobile}
      />
    </div>
  );
}

PriceCheckerChartVdp.propTypes = {
  tmvData: VehicleEntities.NewTmv,
  userMsrp: PropTypes.number,
  userDealerPrice: PropTypes.number,
  bestDealPrice: PropTypes.number,
  setDealRated: PropTypes.func,
  isMobile: PropTypes.bool,
  isPartnerListing: PropTypes.bool,
};
